export default __webpack_public_path__ + "static/wedding_bk_card-9bc76bb35ed853335bc4322e4ee2e8a6.jpeg";